var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',[_c('VideoComponentVermregie'),_c('verm-aseg'),_c('verm-bseg'),_c('white-label'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }